var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"login-m-btn",on:{"click":_vm.handleDidsLogin}},[_c('span',[_vm._v("Did")])])}
var staticRenderFns = []

export { render, staticRenderFns }